import { UnexpectedValueError } from "@anna-money/anna-web-lib/utils";

import type { CompanyFormValues } from "helpers/forms/acn/companyTypes";
import { CompanyStore } from "services/company/companyStore";

export enum CompanyNameEntity {
  Name = "Name",
}

export class CompanyNameAcnStepStore {
  constructor(private readonly _companyStore: CompanyStore) {}

  async updateEntity(data: CompanyFormValues, entity: CompanyNameEntity): Promise<void> {
    switch (entity) {
      case CompanyNameEntity.Name:
        if (!this._companyStore.company) {
          if (data.name && data.namePostfix && data.nameIdenticalAbn) {
            await this._companyStore.createCompany(data.name, data.namePostfix, data.nameIdenticalAbn);
          } else if (data.name && data.namePostfix) {
            await this._companyStore.createCompany(data.name, data.namePostfix);
          } else {
            await this._companyStore.createCompany();
          }
        } else {
          if (data.name && data.namePostfix && data.nameIdenticalAbn) {
            await this._companyStore.updateNameWithAbn(data.name, data.namePostfix, data.nameIdenticalAbn);
          } else {
            await this._companyStore.updateName(data.name, data.namePostfix);
          }
        }
        break;

      default:
        throw new UnexpectedValueError("entity", entity);
    }
  }
}
